<template>
  <picture
          class="hero-img tablet:h-[75vh] desktop:h-[60vh] rounded-img">
    <span aria-hidden="true"
          class="absolute inset-0 w-full h-full bg-gradient-to-b from-black/50 from-0% to-transparent to-66% z-10 pointer-events-none"
    >
    </span>
    <media-source
            :dimensions="[
                { width: 3800, height: 2560 },
                { width: 2500, height: 1170 },
                { width: 1900, height: 1080 },
            ]"
            :media="`(min-width: ${config.ui.breakpoints.tablet.width}px)`"
            :uri=uri
            as="source"
            format="jpg"
            sizes="100vw"
    />

    <media-source
            :dimensions="[
                { width: 3800, height: 2560 },
                { width: 2500, height: 1170 },
                { width: 1900, height: 1080 },
            ]"
            :media="`(min-width: ${config.ui.breakpoints.tablet.width}px)`"
            :uri=uri
            as="source"
            format="webp"
            sizes="100vw"
    />

    <media-source
            :dimensions="[
                { width: 1920 },
                { width: 1200 },
                { width: 780 },
            ]"
            :media="`(max-width: ${config.ui.breakpoints.tablet.width - 1}px)`"
            :uri=uri
            as="source"
            format="webp"
            sizes="100vw"
    />

    <media-source
            :alt="alt || config.siteName"
            :class="imgClass"
            :dimensions="[
                { width: 1920 },
                { width: 1200 },
                { width: 780 },
            ]"
            :uri=uri
            as="img"
            class="object-cover"
            format="jpg"
            loading="eager"
            sizes="100vw"
    />
    <span
            v-if="faded"
            class="hidden tablet:block absolute inset-0 w-full h-full bg-white/65 z-5 pointer-events-none"
    />
  </picture>
</template>

<script lang="ts" setup>
const {uri = '/home/hero.jpg', imgClass = '', faded = false, alt = ''} = defineProps<{
    uri?: string,
    imgClass?: string
    faded?: boolean
    alt?: string
}>()
const config = useRuntimeConfig().public;
</script>

<style lang="scss" scoped>
.hero-img {
  width: 100%;
  position: relative;
  display: block;
  overflow: hidden;
  will-change: transform;

  @media (min-width: 767px) {
    &:after {
      content: '';
      display: block;
      padding-bottom: 100%;
    }

    > img {
      position: absolute;
      inset: 0;
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
}
</style>
